// extracted by mini-css-extract-plugin
export default {"header":"StudentNotesModalHeader_header__-xjjH","title":"StudentNotesModalHeader_title__S5QTm","closeButton":"StudentNotesModalHeader_closeButton__-FFD9"};